import { render, staticRenderFns } from "./ReportGlobalvalueShop.vue?vue&type=template&id=31276fc1&scoped=true&"
import script from "./ReportGlobalvalueShop.vue?vue&type=script&lang=js&"
export * from "./ReportGlobalvalueShop.vue?vue&type=script&lang=js&"
import style0 from "./ReportGlobalvalueShop.vue?vue&type=style&index=0&id=31276fc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31276fc1",
  null
  
)

export default component.exports